import { render, staticRenderFns } from "./ChangeRequests.vue?vue&type=template&id=b67da22e&"
import script from "./ChangeRequests.vue?vue&type=script&lang=js&"
export * from "./ChangeRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports